<template>
  <div class="waw-outcome">
    <div class="waw-outcome__icon waw-outcome__icon--off">&#x1F4AC;</div>
    <div class="waw-outcome__body">
      <p class="waw-outcome__lead">
        We can&rsquo;t set up WhatsApp for a practice in your country.
      </p>
      <p class="waw-outcome__note">
        This is a restriction on WhatsApp&rsquo;s side, not something your practice or Teamio can
        change. Your text messaging is not affected.
      </p>
    </div>
  </div>
</template>

<script>
/**
 * Terminal screen — WhatsApp is not available in this practice's country.
 *
 * Reached from the hard country gate: the practice is in a comprehensively embargoed country, so
 * there is nothing to sell them and nothing to try again. The backend persists the gate result, so
 * this screen renders on every later visit without another Twilio round trip.
 *
 * ── THE TONE IS THE POINT ────────────────────────────────────────────────────────────────────────
 * Neutral, not an error, and explicitly NOT their fault: a practice reading a red failure here will
 * assume they filled something in wrong and try again, or call us to fix an account problem that
 * does not exist. It also says plainly that texting is untouched, because "WhatsApp is unavailable"
 * reads to a worried reader as "my messaging is broken". The route back — a wrong country on the
 * account — is in the copy trio.
 */
export default {
  name: 'WizardBlockedStep',
};
</script>

<style lang="scss" scoped>
@import '../../PatientPayments/tokens';

.waw-outcome {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.waw-outcome__icon {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: $pp-radius-sm;
  background: $pp-brand-subtle;
  font-size: 1.35rem;
  line-height: 1;
}

/* Deliberately NEUTRAL, not a warning colour: nothing here is broken and nothing is theirs to fix. */
.waw-outcome__icon--off {
  background: $pp-surface-sunken;
  filter: grayscale(1);
}

.waw-outcome__body {
  flex: 1 1 auto;
  min-width: 0;
}

.waw-outcome__lead {
  margin: 0 0 0.6rem;
  color: $pp-text-strong;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.6;
}

.waw-outcome__note {
  margin: 0;
  padding: 0.6rem 0.8rem;
  border-radius: $pp-radius-sm;
  background: $pp-surface-sunken;
  color: $pp-text-muted;
  font-size: 0.83rem;
  line-height: 1.6;
}
</style>
